import * as stylex from '@stylexjs/stylex';
import clsx from 'clsx';
import _ from 'lodash';
import { Field, useForm } from 'react-final-form';
import { ImageSelect } from '@/core/ImageSelect.molecule';
import { FormFieldWrapper } from '@/formbuilder/FormFieldWrapper';
import { getFormFieldProps, getValidationFunction } from '@/formbuilder/formbuilder.utilities';
import type { ImageSelectOption } from '@/core/ImageSelect.molecule';
import type { ValidatingFormComponent } from '@/formbuilder/formBuilder.types';

export interface ImageSelectIF extends Omit<ValidatingFormComponent<string>, 'onChange'> {
  component: 'ImageSelectFormComponent';
  onChange?: (option: ImageSelectOption) => void;
  label: string;
  selectOptions: ImageSelectOption[];
  placeholder: string;
  imageSelectClassName?: string;
  customErrorText?: string;
}

export const ImageSelectFormComponent = (props: ImageSelectIF) => {
  const {
    name,
    testId = 'image-select',
    label,
    placeholder,
    value,
    selectOptions,
    validation,
    extendValidation,
    extraClassNames,
    customErrorText,
    imageSelectClassName,
  } = props;

  const defaultValidation = () => _.isUndefined(value);

  const appliedValidation = getValidationFunction(defaultValidation, extendValidation, validation);
  const formState = useForm().getState();
  const showError = _.has(formState.errors, name) && _.has(formState.dirtyFields, name);

  return (
    <FormFieldWrapper
      testId={testId}
      label={label}
      wrapperXstyle={[styles.field, props.wrapperXstyle]}
      extraClassNames={extraClassNames}
      showError={showError}
      customErrorText={customErrorText}>
      <Field name={name} validate={appliedValidation}>
        {({ input, meta }) => {
          const formFieldProps = getFormFieldProps(formState, input, meta, props);

          return (
            <ImageSelect
              name={name}
              placeholder={placeholder}
              value={formFieldProps.value}
              selectOptions={selectOptions}
              extraClassNames={clsx(imageSelectClassName, formFieldProps.className)}
              onChange={formFieldProps.onChange}
            />
          );
        }}
      </Field>
    </FormFieldWrapper>
  );
};

const styles = stylex.create({ field: { flex: '1 1 auto', overflow: 'hidden' } });
